const { styled, Switch } = require("@mui/material");

export const YesNoSwitch = styled(Switch)(({ theme }) => ({
  width: 50,
  height: 26,
  padding: 0,

  "& .MuiSwitch-switchBase": {
    padding: 2,
    transitionDuration: "300ms",

    "&.Mui-checked": {
      transform: "translateX(22px)",
      color: "#fff",

      "& + .MuiSwitch-track": {
        backgroundColor: "#2C4A5A",
        opacity: 1
      },

      "& + .MuiSwitch-track:before": {
        opacity: 1
      },

      "& + .MuiSwitch-track:after": {
        opacity: 0
      }
    }
  },

  "& .MuiSwitch-thumb": {
    width: 22,
    height: 22,
    backgroundColor: "#fff"
  },

  "& .MuiSwitch-track": {
    borderRadius: 14,
    backgroundColor: "#94929c",
    opacity: 1,
    position: "relative",

    "&:before": {
      content: '"YES"',
      position: "absolute",
      left: 5,
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: 8,
      fontWeight: 600,
      color: "#fff",
      opacity: 0,
      transition: "0.3s"
    },

    "&:after": {
      content: '"NO"',
      position: "absolute",
      right: 5,
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: 8,
      fontWeight: 600,
      color: "#fff",
      opacity: 1,
      transition: "0.3s"
    }
  }
}));
